import React, {ReactElement} from 'react';
import {useCookies} from 'react-cookie';
import {FormattedMessage} from 'react-intl';
import DynamicLink from '../../DynamicLink/DynamicLink';
import {CloseIcon} from '../Icons';
import Button, {ButtonVariant} from '../Buttons/Button/Button';
import {cookieDomain, hasSecureCookie, UPDATES_STRIP_COOKIE_NAME} from '../../../constants';
import './UpdatesStrip.scss';

interface Props {
  title: string;
  content: string;
  moreInformationHref?: string;
}

const COOKIE_AGE = 24 * 60 * 60 * 7; // one week

function UpdatesStrip({title, content, moreInformationHref}: Props): ReactElement | null {
  const [cookies, setCookie] = useCookies([UPDATES_STRIP_COOKIE_NAME]);

  const handleClick = () => {
    setCookie(UPDATES_STRIP_COOKIE_NAME, true, {
      maxAge: COOKIE_AGE,
      path: '/',
      domain: cookieDomain,
      secure: hasSecureCookie,
    });
  };

  if (cookies[UPDATES_STRIP_COOKIE_NAME]) {
    return null;
  }

  // @todo update center/left to use isDesktop/isMobile

  return (
    <div className="updatesStrip">
      <div className="updatesStrip__inner">
        <span className="updatesStrip__title">{title}: </span>
        <span className="updatesStrip__content">{content}</span>
        {moreInformationHref && (
          <>
            &nbsp;
            <DynamicLink className="updatesStrip__link unstyledLink noBreakText" href={moreInformationHref}>
              <FormattedMessage id="homepage.updatesStrip.moreInformationLabel" />
            </DynamicLink>
          </>
        )}
      </div>
      <Button
        ariaLabel="close"
        className="updatesStrip__close"
        onClick={handleClick}
        testId="button.updatesStrip.close"
        type="button"
        variant={ButtonVariant.UNSTYLED}
      >
        <CloseIcon />
      </Button>
    </div>
  );
}

export default UpdatesStrip;
